import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectProductsByCompanyIdSiteId, selectProductsByCompanyId, countProductsByCompanyIdSiteId } from './store/reducers';
import { UUID } from 'angular2-uuid';
import { Product } from './product.model';
import * as ProductActions from './store/actions/products.actions';
// import * as MediaLibraryActions from '../media-libraries/store/actions/media-libraries.actions';
import { Observable, of } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  messages$: any;

  constructor(
    private store: Store<any>,
    protected db: AngularFirestore,
  ) {

    const preProducts = [
      '1st message',
      '2nd message',
      '3rd message',
      '4th message',
      '5th message'
    ];

    // this.messages$ = this.product.select(selectAllProducts);

    // for (let i = 0; i < preProducts.length; i++) {
    //   this.addProduct(preProducts[i]);
    // }

    // this.getProducts();
  }


  addProduct(value: any) {
    const product: Product = {
      // id: this.generateUUID(),
      companyId: value.companyId,
      siteId: value.siteId,
      heading: value.heading,
      detail: value.detail,
      file: value.file,
      fileType: value.fileType,
      image: value.image,
      sortOrder: value.sortOrder,
      atProductGroups: value.atProductGroups,
      price: value.price,
      calories: value.calories,
      includesDrink: value.includesDrink,
      productCode: 'value.productCode',
      description: 'value.description',
      descriptionShort: 'value.descriptionShort',
      productGroup: 9999,
      weight: 'value.weight',
      tags: 'value.tags',
      width: 60,
      height: 60,
      sellingPrice: 0,
      xPos: 0,
      yPos: 0,
      useImage: false,
      shippingPrice: 0,
      details: 'value.details',
      atSites: value.atSites,
      dayTimes: value.dayTimes,
      weekDays: value.weekDays,
      af: value.af,
      da: value.da,
      do: value.do,
      ni: value.ni,
      available: value.available,
      html: value.html,
      salesStyle: value.salesStyle,
      veganism: value.veganism,
      chilliMax: value.chilliMax,
    };

    this.store.dispatch(new ProductActions.AddProduct(product));

  }

  addProductFirebase$(product: Product) {
    return this.db.collection('ts__products').add(product);
  }

  updateProductFirebase$(product: any) {
    console.log('updateProductFirebase$: e', product);

    const productsRef: AngularFirestoreDocument<any> = this.db.collection('ts__products').doc(product.id);

    const ProductData: any = Object.assign({}, product);

    return of(productsRef.set(ProductData, { merge: true }));
  }

  deleteProduct(id: any) {
    this.store.dispatch(new ProductActions.DeleteProduct(id));
  }

  destroyProduct(id: any) {
    this.store.dispatch(new ProductActions.DestroyProduct(id));
  }

  destroyProductFirebase$(id: string) {
    return this.db.collection('ts__products').doc(id).delete();
  }

  deleteProductFirebase$(id: string) {
    return this.db.collection('ts__products').doc(id).delete();
  }

  updateProduct(product: any) {
    console.log('updateProductupdateProductupdateProductupdateProduct: e', product);
    this.store.dispatch(
      new ProductActions.UpdateProduct(product)
    );

  }

  getProducts() {
    this.store.dispatch(new ProductActions.FetchProducts());
  }

  getProductsByCompanyId(companyId: string) {
    this.store.dispatch(new ProductActions.FetchProductsByCompanyId(companyId));
  }

  getProductsByCompanyIdSiteId(companyId: string, siteId: string) {
    this.store.dispatch(new ProductActions.FetchProductsByCompanyIdSiteId(companyId, siteId));
  }

  getProductsByCompanyId$(id: string): Observable<any> {

    const productsCollection = this.db.collection<any>('ts__products', ref => ref
      .where('companyId', '==', id)
    );

    return productsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getProductsByCompanyIdSiteId$(companyId: string, siteId: string): Observable<any> {

    const productsCollection = this.db.collection<any>('ts__products', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
    );

    return productsCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  findProductsByCompanyId(id: string): Observable<Product[]> {

    return this.store.select(selectProductsByCompanyId, { id });

  }

  findProductsByCompanyIdSiteId(companyId: string, siteId: string): Observable<Product[]> {
    return this.store.select(selectProductsByCompanyIdSiteId, { companyId, siteId });
  }

  countProductsByCompanyIdSiteId(companyId: string, siteId: string): any {
    return this.store.select(countProductsByCompanyIdSiteId, { companyId, siteId });
  }

  generateUUID(): string{
    return UUID.UUID();
  }
}
